// src/pages/SignUpPage.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import HeaderBar from '../components/HeaderBar';
import Footer from '../components/Footer';
import { apiPost } from '../lib/apiClient';

export default function SignUpPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [challengeQuestion, setChallengeQuestion] = useState('');
  const [challengeAnswer, setChallengeAnswer] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }
    if (!challengeQuestion.trim() || !challengeAnswer.trim()) {
      setError('Challenge question and answer are required.');
      return;
    }
    setLoading(true);
    setError('');
    setMessage('');
    try {
      const res = await apiPost('/api/auth/signup', {
        username,
        password,
        challengeQuestion,
        challengeAnswer
      });
      setMessage(`Welcome, ${res?.username || username}! Your workspace is ready.`);
      setUsername('');
      setPassword('');
      setConfirmPassword('');
      setChallengeQuestion('');
      setChallengeAnswer('');
      setTimeout(() => navigate('/signin', { replace: true }), 600);
    } catch (err) {
      if (err?.status === 409) {
        setError('That username already exists. Please choose a different username.');
      } else {
        setError(err?.msg || err?.message || 'Sign up failed. Try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-shell">
      <HeaderBar />
      <main className="auth-page">
        <div className="card" style={{ maxWidth: 420, margin: '32px auto', padding: 24 }}>
          <h2 style={{ marginTop: 0, marginBottom: 12 }}>Create your account</h2>
          <p style={{ marginTop: 0, color: '#4b5563' }}>
            Choose a challenge question and answer for password resets. Answers are case-insensitive.
          </p>
          <form onSubmit={handleSubmit} style={{ display: 'grid', gap: 12 }}>
            <label style={{ display: 'grid', gap: 4 }}>
              <span>Username</span>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                pattern="[A-Za-z0-9_.@+-]+"
                autoComplete="username"
              />
            </label>
            <label style={{ display: 'grid', gap: 4 }}>
              <span>Password</span>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                minLength={8}
                autoComplete="new-password"
              />
            </label>
            <label style={{ display: 'grid', gap: 4 }}>
              <span>Confirm password</span>
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                minLength={8}
                autoComplete="new-password"
              />
            </label>
            <label style={{ display: 'grid', gap: 4 }}>
              <span>Challenge question</span>
              <input
                type="text"
                value={challengeQuestion}
                onChange={(e) => setChallengeQuestion(e.target.value)}
                required
              />
            </label>
            <label style={{ display: 'grid', gap: 4 }}>
              <span>Challenge answer (case-insensitive)</span>
              <input
                type="text"
                value={challengeAnswer}
                onChange={(e) => setChallengeAnswer(e.target.value)}
                required
              />
            </label>
            <button className="btn primary-btn" type="submit" disabled={loading}>
              {loading ? 'Creating…' : 'Sign up'}
            </button>
          </form>
          {message && <div style={{ marginTop: 12, color: '#065f46' }}>{message}</div>}
          {error && <div style={{ marginTop: 12, color: '#b91c1c' }}>{error}</div>}
          <div style={{ marginTop: 16 }}>
            Already have an account? <button className="about-button" type="button" onClick={() => navigate('/signin')}>Sign in</button>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
